








import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import { Component } from 'vue-property-decorator';
import Vue, { Component as VueComponent } from 'vue';

@Component({
  components: {
    Header,
    Footer
  }
})
export default class App extends Vue {
  
  get theme() {
    const route = this.$route.matched.find(record => {
      return record.meta.theme;
    });

    return route?.meta.theme || 'green';
  }
};
